<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">轮播图管理</el-menu-item>
      <el-menu-item index="2">弹框管理</el-menu-item>
      <el-menu-item index="3">动态页面</el-menu-item>
    </el-menu>
    <div slot="content" class="content_warp">
      <Picture v-if="menuIndex == 1" />
      <DialogManage v-if="menuIndex == 2" />
      <dynamicList v-if="menuIndex == 3" />
    </div>
  </Card>
</template>

<script lang="js">
import Picture from "./Picture.vue"; // 菜单管理
import DialogManage from "./DialogManage.vue"; // 菜单管理
import dynamicList from './dynamicList.vue'
export default {
  name: "mobile",
  components: { Picture,DialogManage,dynamicList },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('mobileIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  mounted() {
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('mobileIndex', key);
    }
  }
};
</script>
<style>
.overflow {
  overflow-y: scroll;
}
.content_warp{
  height: 100%;
  overflow: hidden;
}
</style>